/** A window's vertical extent, in viewport (position: fixed) coordinates. */
export interface VerticalBox {
  top: number;
  height: number;
}

/** The part of the screen that is actually showing, top and bottom. */
export interface VisibleArea {
  top: number;
  bottom: number;
}

/**
 * What is on screen: the visual viewport, which on a tablet or phone ends at the top of the soft keyboard. A native
 * WebView shrinks the window with the keyboard, mobile Safari does not and covers its foot instead; the visual
 * viewport is right in both.
 */
export function visibleArea(): VisibleArea {
  const vv = window.visualViewport;
  return vv ? { top: vv.offsetTop, bottom: vv.offsetTop + vv.height } : { top: 0, bottom: window.innerHeight };
}

/**
 * The box moved up, and shortened if it must be, so it sits wholly inside the visible area with a margin. A box
 * already inside is returned as it is.
 */
export function fitVertically(box: VerticalBox, area: VisibleArea, margin: number): VerticalBox {
  if (box.top >= area.top && box.top + box.height <= area.bottom) return box;
  const height = Math.max(0, Math.min(box.height, area.bottom - area.top - margin * 2));
  const top = Math.max(area.top + margin, Math.min(box.top, area.bottom - margin - height));
  return { top, height };
}
